import { Attachment, FieldValue, RuleProps } from 'types/application';

export const SECT_PERFORMER_ON_GOING = 'performer';

export const EVENT_PERFORMER_FIELDS = [
    {
        sectionID: SECT_PERFORMER_ON_GOING,
        sectionName: '',
        fieldList: [
            {
                id: 'event-title',
                apiID: 'Title',
                label: 'Event Title',
                type: 'longText',
                rule: {
                    disabled: true,
                    customValidate: ({ currentValue }: RuleProps) => {
                        if (currentValue) {
                            const result = /(\b((https?|ftp|file):\/\/|(www\.))[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig.test(
                                currentValue as string
                            );
                            if (result) return 'URL Not Allowed in Title.';
                        }

                        return true;
                    }
                },
                span: 12
            },
            {
                id: 'performer-list',
                label: 'Performer',
                type: 'table',
                subFields: [
                    {
                        id: 'artist',
                        header: 'Name of Artist ',
                        type: 'text',
                        rule: {
                            optionalRequired: true,
                            optionalRequiredMsg: '',
                            baseIds: [`${SECT_PERFORMER_ON_GOING}-performerListDocs`],
                            required: ({ baseValues }: RuleProps) => {
                                const result = Boolean(
                                    baseValues &&
                                        ((baseValues[`${SECT_PERFORMER_ON_GOING}-performerListDocs`] as Attachment[]) || []).filter(
                                            (file: Attachment) => !file.error && !file.deleted
                                        ).length === 0
                                );
                                return result;
                            }
                        }
                    },
                    {
                        id: 'group-band',
                        header: 'Group/Band Name',
                        type: 'text'
                    },
                    {
                        id: 'country',
                        header: 'Country',
                        apiID: 'Country',
                        type: 'dropdown',
                        rule: {
                            optionalRequired: true,
                            optionalRequiredMsg: '',
                            baseIds: [`${SECT_PERFORMER_ON_GOING}-performerListDocs`],
                            required: ({ baseValues }: RuleProps) => {
                                const result = Boolean(
                                    baseValues &&
                                        ((baseValues[`${SECT_PERFORMER_ON_GOING}-performerListDocs`] as Attachment[]) || []).filter(
                                            (file: Attachment) => !file.error && !file.deleted
                                        ).length === 0
                                );
                                return result;
                            }
                        }
                    }
                ],
                span: 12,
                buttonTitle: 'Add Performer',
                rule: {
                    optionalRequired: true,
                    optionalRequiredMsg: '',
                    revalidate: [`${SECT_PERFORMER_ON_GOING}-performerListDocs`],
                    baseIds: [`${SECT_PERFORMER_ON_GOING}-performerListDocs`],
                    required: ({ baseValues }: RuleProps) => {
                        const validFiles = baseValues
                            ? ((baseValues[`${SECT_PERFORMER_ON_GOING}-performerListDocs`] as Attachment[]) || []).filter(
                                  (item: Attachment) => !item.deleted && !item.error
                              )
                            : [];

                        const result = Boolean(baseValues && !validFiles.length);
                        return result;
                    }
                }
            },
            {
                id: 'performerListDocs',
                label: 'Upload Performer List',
                type: 'file',
                category: 'PerformerDetails',
                span: 12,
                rule: {
                    optionalRequired: true,
                    optionalRequiredMsg: '',
                    baseIds: [`${SECT_PERFORMER_ON_GOING}-performer-list`],
                    revalidate: [`${SECT_PERFORMER_ON_GOING}-performer-list`],
                    required: ({ baseValues }: RuleProps) => {
                        const base =
                            baseValues &&
                            ((baseValues[`${SECT_PERFORMER_ON_GOING}-performer-list`] as { [key: string]: FieldValue }[]) || []).filter(
                                (values: { [key: string]: FieldValue }) => !values.deleted
                            );
                        const result = Boolean(baseValues && !(base || []).length);
                        return result;
                    }
                },
                mimeTypes: [
                    'application/pdf',
                    'application/vnd.ms-excel',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                ],
                fileTypes: ['.pdf', '.xls', '.xlsx', '.doc', '.docx']
            }
        ]
    }
];
